// Mapa de Seções → Cores

import {
  Store,
  Factory,
  Wrench,
  Truck,
  Hotel,
  Droplets,
  BookOpen,
  HeartPulse,
  Palette,
  Building2,
  Leaf,
  Zap,
  Landmark,
  ClipboardList,
  Briefcase,
  Shield,
  GraduationCap,
  User,
  Shirt,
  Cog
} from "lucide-react";

export const CNAE_ICONS: Record<string, any> = {
  A: Leaf,         // Agricultura
  B: Building2,    // Indústrias extrativas
  C: Factory,      // Indústrias de transformação
  D: Zap,        // Eletricidade e gás
  E: Droplets,     // Água/esgoto
  F: Wrench,       // Construção
  G: Store,        // Comércio
  H: Truck,        // Transporte
  I: Hotel,        // Alojamento e alimentação
  J: BookOpen,     // Informação/comunicação
  K: Landmark,     // Financeiro
  L: Building2,    // Imobiliário
  M: ClipboardList,// Profissionais/científicos
  N: Briefcase,    // Serviços administrativos
  O: Shield,       // Administração pública
  P: GraduationCap,// Educação
  Q: HeartPulse,   // Saúde
  R: Palette,      // Arte e cultura
  S: User,         // Outros serviços
  T: Shirt,        // Serviços pessoais
  U: Cog,          // Organismos internacionais
};

export const CNAE_COLORS: Record<string, string> = {
  A: '#4CAF50',
  B: '#5D4037',
  C: '#455A64',
  D: '#FFC107',
  E: '#00BCD4',
  F: '#FF9800',
  G: '#F44336',
  H: '#78909C',
  I: '#FF7043',
  J: '#9C27B0',
  K: '#2E7D32',
  L: '#9e2703ff',
  M: '#006064',
  N: '#998585ff',
  O: '#1A237E',
  P: '#3F51B5',
  Q: '#009688',
  R: '#E91E63',
  S: '#292828ff',
  T: '#F8BBD0',
  U: '#448AFF',
};

export function getIconByCnae(codigo?: string) {
  const section = getCnaeSection(codigo);
  if (!section) return Store; // fallback
  return CNAE_ICONS[section] ?? Store;
}

export function getCnaeSection(codigo?: string): string | null {
  if (!codigo || typeof codigo !== "string") return null;
  

  const clean = codigo.replace(/\D/g, ""); // remove caracteres não-números
  if (clean.length < 2) return null;

  const prefix = parseInt(clean.substring(0, 2));
    
  if (prefix >= 1 && prefix <= 3) return 'A';
  if (prefix >= 5 && prefix <= 9) return 'B';
  if (prefix >= 10 && prefix <= 33) return 'C';
  if (prefix === 35) return 'D';
  if (prefix >= 36 && prefix <= 39) return 'E';
  if (prefix >= 41 && prefix <= 43) return 'F';
  if (prefix >= 45 && prefix <= 47) return 'G';
  if (prefix >= 49 && prefix <= 53) return 'H';
  if (prefix >= 55 && prefix <= 56) return 'I';
  if (prefix >= 58 && prefix <= 63) return 'J';
  if (prefix >= 64 && prefix <= 66) return 'K';
  if (prefix === 68) return 'L';
  if (prefix >= 69 && prefix <= 75) return 'M';
  if (prefix >= 77 && prefix <= 82) return 'N';
  if (prefix === 84) return 'O';
  if (prefix === 85) return 'P';
  if (prefix >= 86 && prefix <= 88) return 'Q';
  if (prefix >= 90 && prefix <= 93) return 'R';
  if (prefix >= 94 && prefix <= 96) return 'S';
  if (prefix === 97 || prefix === 98) return 'T';
  if (prefix === 99) return 'U';

  return null;
}


export function getColorByCnae(codigo?: string): string {
  const section = getCnaeSection(codigo);
  if (!section) return '#000000'; // fallback seguro
  return CNAE_COLORS[section] ?? '#000000';
}

